import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button } from '@mui/material';

import { ICardProps } from './Card.interface';

import './style.scss';

const Card: FC<ICardProps> = ({ icon, title, description, link }) => (
  <Box className="card">
    <Box className="card__text-content">
      <Box className="card__header">
        <Box className="card__icon">
          <Box component="img" src={icon} />
        </Box>

        <Box className="card__title">
          <h5>{title}</h5>
        </Box>
      </Box>

      {description && (
        <Box className="card__description">
          <p className="small">{description}</p>
        </Box>
      )}
    </Box>

    <Box className="card__link">
      {link.href && (
        <Button variant="contained" href={link.href} target="_blank" className="card__link-button">
          {link.title}
        </Button>
      )}

      {link.routerLink && (
        <Link to={link.routerLink}>
          <Button variant="contained" className="card__link-button">
            {link.title}
          </Button>
        </Link>
      )}
    </Box>
  </Box>
);

export default Card;
